export const getInitials = (fullName: string) => {
  const nameParts = fullName.split(" ");
  if (nameParts.length > 1) {
    return (
      nameParts[0].slice(0, 1) + nameParts[nameParts.length - 1].slice(0, 1)
    );
  }
  return nameParts[0].slice(0, 1);
};
